import {Injectable, NgZone} from '@angular/core';
import {AlertService} from '../../../common/alert-service/alert.service';
import {ErpAlertContextModel} from './erp-react-alert-context';

@Injectable({providedIn: 'root'})
export class ErpAngularZonedAlertService {
  constructor(private ngZone: NgZone, private alertService: AlertService) {
  }

  add(type: 'success' | 'danger', message: string): void {
    return this.ngZone.run(() => {
      this.alertService.add(type, message);
    });
  }

  context(): ErpAlertContextModel {
    const self = this;
    return {
      add: (type, message) => self.add(type, message),
    };
  }
}
